export default {
  ADDED: 'Nytt Tåg',
  INCREASED: 'Utökad',
  DECREASED: 'Kortad',
  CANCELED: 'Inställd',
  PARTIAL_CANCELLATION: 'Delinställd',
  CANCELED_STOP: 'Slopat uppehåll'
}
